import styles from "./TaxonomyColumn.module.css";

export type CommentaryTaxonomyValues = {
  publication: string;
  edition: string;
  region: string;
  practice: string;
  firm: string;
};

type TaxonomyColumnProps = {
  taxonomy: CommentaryTaxonomyValues;
};

const TAXONOMY_FIELDS: Array<{
  key: keyof CommentaryTaxonomyValues;
  label: string;
}> = [
  { key: "publication", label: "Publication" },
  { key: "edition", label: "Edition" },
  { key: "practice", label: "Practice" },
  { key: "firm", label: "Firm" },
  { key: "region", label: "Region" },
];

function getTaxonomyValue(value: string | null | undefined): string {
  if (!value) {
    return "-";
  }

  const trimmedValue = value.trim();
  return trimmedValue.length > 0 ? trimmedValue : "-";
}

export function TaxonomyColumn({ taxonomy }: TaxonomyColumnProps) {
  return (
    <div className={styles.taxonomyColumn}>
      <div className={styles.taxonomyContent}>
        {TAXONOMY_FIELDS.map(({ key, label }) => (
          <div key={key} className={styles.taxonomyRow}>
            <span className={styles.taxonomyLabel}>{label}:</span>
            <span className={styles.taxonomyValue}>{getTaxonomyValue(taxonomy[key])}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
